module.exports = __webpack_public_path__ + "img/教学互动.dce80301.svg";